import useMediaQuery from '@material-ui/core/useMediaQuery';

export const useScreenSizeHook = () => {
  const mobileViewMatches = useMediaQuery('(max-width:529px)');
  const tabletViewMatches = useMediaQuery('(max-width:949px)');
  const desktopViewMatches = useMediaQuery('(max-width:1349px)');

  return {
    mobileView: mobileViewMatches,
    tabletView: !mobileViewMatches && tabletViewMatches,
    desktopView: !mobileViewMatches && !tabletViewMatches && desktopViewMatches,
  };
};
